import { CompPoints, CurrentIp, User } from '@repo-level/core-front';
import { Country } from 'helpers/conf';
import { QuestPoint, questPoints } from 'helpers/quest';
import { TFunction } from 'i18next';

export const detectLoyaltyData = (questPoints: QuestPoint[]) => (
  compPoints?: CompPoints
) => {
  const points = compPoints?.persistent?.points;

  const currentIndexPoint = questPoints.findIndex(
    ({ cp }, index) =>
      points != null &&
      cp <= points &&
      (questPoints[index + 1] == null || points < questPoints[index + 1].cp)
  );

  const currentLevel = questPoints[currentIndexPoint];
  const nextLevel = questPoints[currentIndexPoint + 1];

  return {
    level: currentLevel?.level || 0,
    prize: currentLevel?.prize,
    nextPrize: nextLevel?.prize || currentLevel?.prize,
    compPoints: points || 0,
    fromCompPoints: currentLevel?.cp || 0,
    toCompPoints: nextLevel?.cp || points || 0,
  };
};

export const getLoyaltyData = detectLoyaltyData(questPoints);

export interface FullInformationFormApi {
  firstName: string;
  lastName: string;
  dateOfBirth?: {
    day: string;
    month: string;
    year: string;
  };
  mobilePhone: {
    code: string;
    number: string;
  };
  country: string;
  city: string;
  address: string;
  postalCode: string;
  state?: string;
}

const isFrance = (currentIp?: CurrentIp) =>
  currentIp?.countryCode === Country.France;

export const checkCompleteUserInformation = (
  user?: User,
  currentIp?: CurrentIp
) => {
  if (isFrance(currentIp)) {
    return (
      !!user?.firstName &&
      !!user?.lastName &&
      !!user?.dateOfBirth &&
      !!user?.gender
    );
  }

  return (
    !!user?.firstName &&
    !!user?.lastName &&
    !!user?.dateOfBirth &&
    !!user?.mobilePhone &&
    !!user?.country &&
    !!user?.state === null &&
    !!user?.city &&
    !!user?.address &&
    !!user?.postalCode &&
    !!user?.gender
  );
};

export const getIsFormCompleted = (
  values: FullInformationFormApi,
  isFR: boolean
) => {
  if (isFR) {
    return (
      !!values.firstName &&
      !!values.lastName &&
      !!values.dateOfBirth?.day &&
      !!values.dateOfBirth?.month &&
      !!values.dateOfBirth?.year &&
      !!values.mobilePhone?.number &&
      !!values.city &&
      !!values.address &&
      !!values.postalCode
    );
  }

  return (
    !!values.firstName &&
    !!values.lastName &&
    !!values.dateOfBirth?.day &&
    !!values.dateOfBirth?.month &&
    !!values.dateOfBirth?.year &&
    !!values.mobilePhone?.code &&
    !!values.mobilePhone?.number &&
    !!values.country &&
    !!values.city &&
    !!values.address &&
    !!values.postalCode
  );
};

export const DEFAULT_GENDER = 'm';

export const getGenderOptions = (t: TFunction) => [
  {
    name: t('personal:male'),
    value: 'm',
  },
  {
    name: t('personal:female'),
    value: 'f',
  },
];
